module.exports = __webpack_public_path__ + "ArghyaSamanta-1b6f8512.webp";